module.exports = __webpack_public_path__ + "img/11.d4606080.jpg";